import { useCallback, useEffect, useState } from 'react';

const useDebounceCallback = <F extends (...args: any[]) => any>(
  fn: F,
  delay: number,
  deps: any[]
) => {
  type Args = Parameters<F>;
  const [args, setArgs] = useState<Args | undefined>();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const callback = useCallback(fn, deps);

  useEffect(() => {
    if (!args) {
      return;
    }
    const h = setTimeout(() => {
      callback(...args);
      setArgs(undefined);
    }, delay);

    return () => clearTimeout(h);
  }, [args, callback, delay]);

  return useCallback((...args: Args) => {
    setArgs(args);
  }, []);
};

export default useDebounceCallback;
